import moment from 'moment'
import styles from "../../../pages/Calendar/index.module.css";
import iconLeft from "../../../assets/images/icons/calendar-icon-left.svg";
import iconRight from "../../../assets/images/icons/calendar-icon-right.svg";
import CalendarEventCreateForm from "../CalendarEventCreate/CalendarEventCreateForm";
import React, {useState} from "react";
import addIcon from "../../../assets/images/icons/add.png";

export const HeaderToolbar = (toolbar) => {
    const { date, onNavigate, handleOpen } = toolbar;
    const [currentDate, setCurrentDate] = useState(date);

    const goToBack = () => {
        const newDate = moment(currentDate).subtract(1, 'month');
        setCurrentDate(newDate);
        onNavigate('prev', newDate);
    };

    const goToNext = () => {
        const newDate = moment(currentDate).add(1, 'month');
        setCurrentDate(newDate);
        onNavigate('next', newDate);
    };

    const label = () => {
        const date = moment(currentDate);
        return (
            <span>
        <b>{date.format('MMMM')}</b>
        <span> {date.format('YYYY')}</span>
      </span>
        );
    };


    return (
        <div className={styles.calendar_header}>
            <div className={styles.header_inner}>
                <h2 className={styles.calendar_title}>{label()}</h2>
                <div className={styles.btns_box}>
                    <button className={styles.calendar_btns} onClick={goToBack}>
                        <img src={iconLeft} alt="icon" />
                    </button>
                    <button className={styles.calendar_btns} onClick={goToNext}>
                        <img src={iconRight} alt="icon" />
                    </button>
                </div>
            </div>
            <div className={styles.header_inner}>
                <button onClick={handleOpen} className={styles.add_btn}>
                    <img src={addIcon} alt="icon" />
                    Создать новый
                </button>
            </div>
        </div>
    );
};